import { useEffect, useState } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { ReactComponent as ChevronRightSvg } from '../../../../assets/svg/chevron-right.svg';
import { ReactComponent as ChevronLeftSvg } from '../../../../assets/svg/chevron-left.svg';
import { ReactComponent as PieChartSvg } from '../../../../assets/svg/pie-chart.svg';
import Feedback from '../../../../components/feedback';
import request from '../../../../lib/request';

ChartJS.register(ArcElement, Tooltip, Legend);

const DailyMealPlan = () => {
  const [feedback, setFeedback] = useState({});
  const [mealPlan, setMealPlan] = useState({});

  useEffect(() => {
    getCurrentProgram();
  }, []);

  const getCurrentProgram = async () => {
    try {
      const { result } = await request.get('/program');
      if (result) {
        const { programId } = result;
        await getFeedback(programId);
        await getMealPlan(programId);
      }
    } catch (err) {
      console.log('err:: ', err);
    }
  };

  const getFeedback = async (programId) => {
    try {
      const res = await request.get(`/meal/feedback?programId=${programId}`);
      if (res.result) {
        setFeedback(res.result);
      }
    } catch (err) {
      console.log('err:: ', err);
    }
  };

  const getMealPlan = async (programId) => {
    try {
      const { result } = await request.get(`/meal/plan?programId=${programId}`);
      if (result) {
        setMealPlan(result);
      }
    } catch (err) {
      console.log('err:: ', err);
    }
  };

  const calculateDailyTotal = (plan, key) => {
    const total = plan.reduce((acc, curr) => {
      return acc + Number(curr[key]);
    }, 0);
    return Number(total);
  };

  return (
    <div className='space-y-4'>
      <Feedback
        type='Meal'
        feedback={feedback}
      />
      {mealPlan.latest && (
        <div className='space-y-2 bg-secondary rounded-xl p-2'>
          <div className='font-bold text-white'>
            Meal Plan: {mealPlan.latest.plan.title}
          </div>
          <div className='rounded-xl px-3 py-2 bg-tertiary'>
            <div className='flex items-center mb-1'>
              <div className='font-bold text-white'>Daily total</div>
            </div>
            <div className='flex justify-between items-center text-xs text-white'>
              <div className='px-2 py-1 rounded-xl border bg-white/10'>
                {calculateDailyTotal(mealPlan.latest.plan.items, 'calories')}{' '}
                Cal
              </div>
              <div className='px-2 py-1 rounded-xl bg-protein/30 border border-protein'>
                Protein{' '}
                {calculateDailyTotal(mealPlan.latest.plan.items, 'proteins')}g
              </div>
              <div className='px-2 py-1 rounded-xl bg-fats/30 border border-fats'>
                Fat {calculateDailyTotal(mealPlan.latest.plan.items, 'fat')}g
              </div>
              <div className='px-2 py-1 rounded-xl bg-carbs/30 border border-carbs'>
                Carbs {calculateDailyTotal(mealPlan.latest.plan.items, 'carbs')}
                g
              </div>
            </div>
          </div>
          <div className='relative'>
            <ChevronLeftSvg
              className='absolute top-[50%] w-5 opacity-40'
              fill='white'
            />
            <ChevronRightSvg
              className='absolute top-[50%] right-0 w-5 opacity-40'
              fill='white'
            />
            <div className='flex gap-4 snap-x overflow-x-scroll scrollbar-hidden snap-mandatory'>
              {mealPlan.latest.plan.items.map((item, i) => (
                <div
                  key={i}
                  className='snap-always snap-center px-3 py-2 w-full shrink-0 flex flex-col justify-center items-center bg-tertiary rounded-xl'
                >
                  <div className='text-white'>
                    {item.name}{' '}
                    <span className='bg-white/10 px-2 rounded-xl border border-white/30 text-sm'>
                      {item.calories} Cal
                    </span>
                  </div>
                  <div>
                    {item.proteins === 0 &&
                    item.fat === 0 &&
                    item.carbs === 0 ? (
                      <div className='aspect-square flex justify-center items-center p-12 gap-2'>
                        <PieChartSvg className='opacity-10' />
                        <div className='opacity-20'>Not Specified</div>
                      </div>
                    ) : (
                      <Pie
                        data={{
                          labels: [
                            `Proteins (${item.proteins}g)`,
                            `Fat (${item.fat}g)`,
                            `Carbs (${item.carbs}g)`,
                          ],
                          datasets: [
                            {
                              label: 'grams(g)',
                              data: [item.proteins, item.fat, item.carbs],
                              backgroundColor: [
                                'rgba(255, 107, 107, 0.2)',
                                'rgba(255, 217, 61, 0.2)',
                                'rgba(78, 205, 196, 0.2)',
                              ],
                              borderColor: [
                                'rgba(255, 107, 107, 1)',
                                'rgba(255, 217, 61, 1)',
                                'rgba(78, 205, 196, 1)',
                              ],
                              borderWidth: 1,
                            },
                          ],
                        }}
                        options={{
                          plugins: {
                            legend: {
                              labels: { color: 'rgba(255, 255, 255, 0.8)' },
                            },
                          },
                        }}
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DailyMealPlan;
